{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "tablets": "أجهزة التابلت",
    "connectedSystems": "الأنظمة المرتبطة",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "organisation": "بيانات المؤسسة",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "toggleHint": "إظهار أو إخفاء القائمة",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "brand": "المسافر"
}
